import React, { memo, useState } from 'react';

import { MdInfo } from 'react-icons/md';
import { BottomSheet } from 'react-spring-bottom-sheet';

import BottomSheetTile
  from '../../../../../components/BottomSheetTile/BottomSheetTile';
import { useTheme } from '../../../../../context/ThemeProvider';
import {
  IServiceRequestMessage,
} from '../../../../../types/tqConnectTypes/service-requests';
import MessageInfoModal from './MessageInfoModal';

interface Props {
  serviceRequestId: string;
  message: IServiceRequestMessage;
  goToUserProfile: (userId: string) => void;
  isOpen: boolean;
  onClose: () => void;
}

const MessageActions: React.FC<Props> = ({
  serviceRequestId,
  message,
  goToUserProfile,
  isOpen,
  onClose,
}) => {
  const { colors } = useTheme();
  const [isMessageInfoModalOpen, setIsMessageInfoModalOpen] = useState(false);

  return (
    <>
      <BottomSheet open={isOpen} onDismiss={onClose}>
        <BottomSheetTile
          title="Message info"
          icon={<MdInfo color={colors.ICON} size={24} />}
          onClick={() => {
            onClose();
            setIsMessageInfoModalOpen(true);
          }}
        />
      </BottomSheet>

      <MessageInfoModal
        key={`message-info-modal-${message._id}`}
        serviceRequestId={serviceRequestId}
        roomId={message.room}
        messageId={message._id}
        isModalOpen={isMessageInfoModalOpen}
        closeModal={() => setIsMessageInfoModalOpen(false)}
        goToUserProfile={goToUserProfile}
      />
    </>
  );
};

export default memo(MessageActions);
